var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          staticClass: "d-block pt-0",
          attrs: {
            cols: "12"
          }
        },
        _vm._l(_vm.ticketBanners, function(ticketBanner, i) {
          return _c(
            "v-alert",
            {
              key: "tb-".concat(i),
              staticClass: "py-3 px-1 mb-3",
              attrs: {
                type: "warning",
                color: "red lighten-1"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "prepend",
                    fn: function fn() {
                      return [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mx-2 d-none d-sm-block white--text"
                          },
                          [_vm._v("mdi-alert-circle-outline")]
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            },
            [
              _c(
                "div",
                {
                  staticClass: "hidden-xs-only white--text"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex justify-space-between align-center"
                    },
                    [
                      _c("div", [
                        _c(
                          "p",
                          {
                            staticClass: "font-weight-bold mb-0"
                          },
                          [
                            _vm._v(
                              _vm._s(ticketBanner.title) +
                                " | " +
                                _vm._s(ticketBanner.ticket_mask_id)
                            )
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticClass: "mb-0"
                          },
                          [_vm._v(_vm._s(ticketBanner.message))]
                        )
                      ]),
                      _c(
                        "gg-btn",
                        {
                          staticClass: "flex-shrink mr-2",
                          attrs: {
                            dark: "",
                            color: "red",
                            tile: "",
                            to: {
                              name: "ticket_view",
                              params: {
                                ticketid: ticketBanner.ticket_mask_id
                              }
                            }
                          }
                        },
                        [_vm._v(" View Ticket ")]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "hidden-sm-and-up white--text"
                },
                [
                  _c("div", [
                    _c(
                      "p",
                      {
                        staticClass: "font-weight-bold"
                      },
                      [_vm._v(_vm._s(ticketBanner.title))]
                    ),
                    _c("p", [_vm._v(_vm._s(ticketBanner.message))])
                  ]),
                  _c(
                    "router-link",
                    {
                      staticClass: "white--text fw-bold underline",
                      attrs: {
                        to: {
                          name: "cancellations",
                          params: {
                            ticketid: ticketBanner.ticket_mask_id
                          }
                        }
                      }
                    },
                    [_vm._v(" View Ticket ")]
                  )
                ],
                1
              )
            ]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }